
/**
 * [convertVolume Converts volume from one metric to another]
 * @param  {String} from
 * @param  {String} to
 * @param  {float} value
 * @return {Float}
*/

// const validMetrics = ['m3', 'cdm', 'cft', 'ccm', 'gal', 'hl'];

// const volumeMapping = {
//   m3: 35.314666721489, // cubic meter
//   hl: 3.5314666721489, // hectoliter
//   cdm: 1 / 28.316846592, // cubic dentimeter
//   cft: 1, // cubic foot
//   ccm: 1 / 28316.846592, // cubic centimeter
//   gal: 1 / 7.4805194805195, // gallon
// };

const convert = require('convert-units');

const system = {
  cft: 'ft3',
  ccm: 'cm3',
  cdm: 'l',
};

function convertWeight(from, to, value) {
  const systemFrom = system[from] || from;
  const systemTo = system[to] || to;
  return convert(value).from(systemFrom).to(systemTo);
}

module.exports = convertWeight;
